import { render, staticRenderFns } from "./newBotModal.vue?vue&type=template&id=0fe0aa53&scoped=true&"
import script from "./newBotModal.vue?vue&type=script&lang=js&"
export * from "./newBotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0aa53",
  null
  
)

export default component.exports